import axios from 'axios'
import { errorHandler } from '@/shared/errorHandler'

export default {
    loginSebrae(usuario) {
        let promisse = axios.post(
            `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao/autenticacao/login/sebrae`,
            usuario
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    loginExterno(usuario) {
        let promisse = axios.post(
            `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH
            }/administracao/autenticacao/login/${usuario.tipoAcesso == 1 ? 'pj' : 'pf'}`,
            usuario
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarNovaSenha(esqueciMinhaSenhaDto) {
        let promisse = axios.post(
            `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao/autenticacao/esqueciminhasenha`,
            esqueciMinhaSenhaDto
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
